// @ts-ignore
const envBackendUrl = process.env.BACKEND_URL;

function localDevHostname() {
  if (typeof window === 'undefined') return null;
  return window.location.hostname;
}

/**
 * Empty string means same-origin (Vite proxies /events and /api in local dev).
 */
export function resolveBackendUrl(envUrl = envBackendUrl, hostname = localDevHostname()) {
  // Local Vite must stay same-origin so /api is proxied. Production CORS
  // does not allow localhost:4173, so an env BACKEND_URL here falls back to sample.
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '';
  }
  if (envUrl && String(envUrl).trim() !== '') {
    return String(envUrl).trim().replace(/\/$/, '');
  }
  return 'https://api.livenow-app.com';
}

const getBackendUrl = () => resolveBackendUrl();

export const BACKEND_URL = getBackendUrl();

if (typeof window !== 'undefined') {
}

export const buildApiUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${BACKEND_URL}/${cleanEndpoint}`;
};

export const validateBackendUrl = () => {
  const url = BACKEND_URL;
  if (url === '') return true;
  const issues = [];
  
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    issues.push('Backend URL must start with http:// or https://');
  }
  
  if (url.includes('livenow-app.com') && !url.includes('api.livenow-app.com')) {
    issues.push('Backend URL should use api.livenow-app.com subdomain, not livenow-app.com');
  }
  
  if (issues.length > 0) {
    return false;
  }
  
  return true;
};

if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  validateBackendUrl();
}

if (typeof window !== 'undefined') {
  window.getAccessToken = async () => {
    try {
      const { supabase } = await import('./supabase');
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (error) {
        return null;
      }
      
      if (session?.access_token) {
        return session.access_token;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  };
}

